import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { HintDesktop as Hint } from '@alfa-bank/site-hint/desktop';
import { PureInput } from '@alfa-bank/site-pure-input';
// TODO: https://jira.moscow.alfaintra.net/browse/ALFABANKRU-83779
// eslint-disable-next-line package-imports/no-core-components-imports
import { Input as CoreInput } from '@alfalab/core-components-input';
import { CheckmarkCircleMIcon as IconSuccess } from '@alfalab/icons-glyph/CheckmarkCircleMIcon';
import { ExclamationCircleMIcon as IconError } from '@alfalab/icons-glyph/ExclamationCircleMIcon';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';

import { Input as Component } from './input';
import type { TInput, IDeps } from './models/models';
import styles from './styles/styles.css';

// Компоненту не требуется функционал стайлера
// eslint-disable-next-line styler/check-styler
export const Input = createWidget<IDeps, TInput>({
    styles,
    CoreInput,
    IconError,
    IconSuccess,
    PureInput,
    Hint,
    Text,
})(Component);
